import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

interface IStepsRowProps {
  color: string;
  number: string;
  heading: string;
  text: string;
  loanAmount?: string;
}

const colorIndexesWrap = {
  green: 2,
  blue: 2,
  red: 2,
  blueGreen: 2,
  blueRed: 2,
  blueYellow: 35,
};

export const StepsRow = ({ color, number, heading, text, loanAmount }: IStepsRowProps) => {
  return (
    <View style={[styles.wrap, getColorObjectStyleByRecord(colorIndexesWrap, 'backgroundColor')]} wrap={false}>
      <View style={[{ backgroundColor: color }, styles.numberWrap]}>
        <Text style={styles.number}>{number}</Text>
      </View>
      <View style={styles.infoWrap}>
        {loanAmount && (
          <View style={styles.loanWrapper}>
            <Text style={[styles.text, styles.loanText]}>{loanAmount}</Text>
          </View>
        )}
        <View style={styles.textWrap}>
          <Text style={[{ color }, styles.heading]}>{heading}</Text>
          <Text style={styles.text}>{text.replace(/\r?\n|\r/g, '')}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    width: '100%',
    minHeight: '72px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#212121',
    marginBottom: '10px',
  },
  numberWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '55px',
    height: '100%',
  },
  number: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '18px',
    color: '#FFFFFF',
  },
  infoWrap: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  textWrap: {
    padding: '5px 13px 5px 15px',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  heading: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '9px',
    marginBottom: 4,
  },
  text: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '9px',
  },
  loanWrapper: {
    width: '75.48px',
    height: '66.71px',
    borderRight: '0.5px dotted #77787C',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loanText: {
    fontWeight: 600,
    color: '#1B1B1B',
  },
});
